export default "/10f6ea76d4f5bb23a08f9eb738b7def2.jpg";